import Plot from "react-plotly.js";
import CardHeader from "./common/CardHeader";
import ViewAllArrowIcon from '../../../assets/icons/ViewAllArrowIcon.svg?react';
import { useSuperDashboardContext } from "../superdashboard/context/SuperDashboardContext";
import { COMPANY_MODAL_KEYS } from "../../../utils/enum";
import {
  pieCardClasses,
  pieContentClasses,
  pieChartWrapperClasses,
  pieLegendClasses,
  pieLegendItemClasses,
  pieLegendDotClasses,
  pieLegendTextClasses,
  pieNoDataClasses,
  pieViewAllClasses,
} from "../../../components/common/dashboardClasses";

const CaseVolumeByCustomerPie = () => {
  const { pieData: data, openModalByKey } = useSuperDashboardContext();

  const plotColors = [
    "#1f4b7a",
    "#1fa9a0",
    "#c05da5",
    "#eb8a7a",
    "#f5dc85",
  ];

  const isEmpty = !data || data.length === 0;

  const topFiveLegendData = (data || []).slice(0, 5);

  return (
    <div className={pieCardClasses}>
      <CardHeader
        title="Case Volume by Customer"
      />
      <div className={pieContentClasses}>
        {isEmpty ? (
          <div className={pieNoDataClasses}>No data available</div>
        ) : (
          <div className={pieChartWrapperClasses}>

            <Plot
              data={[
                {
                  type: "pie",
                  labels: data.map((d) => d.name),
                  values: data.map((d) => d.count),
                  marker: {
                    colors: plotColors,
                  },
                  sort: false,
                  hole: 0.50,
                  hoverinfo: "label+value+percent",
                  textinfo: "none",
                },
              ]}
              layout={{
                height: 240,
                width: 240,
                margin: { t: 10, b: 10, l: 10, r: 10 },
                showlegend: false,
              }}
              config={{ displayModeBar: false, responsive: true }}
            />
          </div>
        )}

        {!isEmpty && <div className={pieLegendClasses}>
          {topFiveLegendData.map((item, index) => (
            <div key={index} className={pieLegendItemClasses}>
              <span className={pieLegendDotClasses}
                style={{
                  backgroundColor: plotColors[index % plotColors.length],
                }}
              />
              <span className={pieLegendTextClasses}>{item.name}</span>
            </div>
          ))}
          {data.length >= 5 && (<span onClick={() => openModalByKey(COMPANY_MODAL_KEYS.CASE_VOLUME)} className={pieViewAllClasses}>View All <ViewAllArrowIcon className="text-primary" /></span>)}
        </div>}
      </div>
    </div>
  );
};

export default CaseVolumeByCustomerPie;
